export default __webpack_public_path__ + "static/media/019-stand.c5d2e038.svg";